import TuneIcon from "@mui/icons-material/Tune";
import { Button, Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { PatientSubscription } from "src/api/types";
import WhiteCard from "src/shared/components/WhiteCard";
import { useTranslation } from "react-i18next";
import { NavigateFunction } from "react-router-dom";

interface MedRemindersCardProps {
  subscription: PatientSubscription;
  page: string;
  navigate: NavigateFunction;
}

const ManageSubscriptionCard = ({
  navigate,
  subscription,
  page,
}: MedRemindersCardProps) => {
  const { t } = useTranslation();
  const component = "manageSubscriptionCard";

  const handleClick = useCallback(() => {
    navigate(`/my-account/subscriptions/${subscription.id}`);
  }, [navigate, subscription.id]);

  return (
    <Button
      component={WhiteCard}
      variant="text"
      onClick={handleClick}
      sx={{
        color: "#000000",
        flexGrow: 1,
        direction: "row",
        alignItems: "flex-start",
        padding: "20px",
        borderRadius: "10px",
      }}
    >
      <Stack direction="row" alignItems="center" gap={2}>
        <TuneIcon />
        <Typography fontWeight={600}>
          {t(`${page}.${component}.title`)}
        </Typography>
      </Stack>
    </Button>
  );
};

export default ManageSubscriptionCard;
